export default "__VITE_ASSET__GUsW75fE__"